export const THUMB_SIZE = 24;
export const SLIDER_HEIGHT = 8;
export const MARKER_SIZE = 4;
export const LABEL_HEIGHT = 20;
